<template>
  <app-layout>
    <app-step class="step--data">
      <div class="flex flex-start flex-wrap xl:flex-nowrap lg:space-x-20">
        <app-box-header title="Forma de pago">
          <p>
            {{$t("step.payment_safe")}}
          </p>
          <div class="flex xl:space-x-5 mt-6 flex-wrap xl:flex-nowrap">
            <redsys-component></redsys-component>
            <paypal-component></paypal-component>
          </div>
        </app-box-header>
      </div>
    </app-step>
  </app-layout>
</template>

<script>
import axios from "axios";

export default {};
</script>

<style>
</style>
